import React from "react";
import DashboardSidebar from "../DashboardSidebar";
import DashboardHeader from "../DashboardHeader";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const DashboardLayout = () => {
  const { user } = useAuth();
  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="dashboard-layout-container">
      <DashboardSidebar />
      <div className="layout-container">
        <DashboardHeader />
        <div className="content-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
